document.addEventListener("DOMContentLoaded", function() {
  // Filter gallery images based on the current variant id.
  function updateGallery(selectedVariantId) {
    document.querySelectorAll('.product-gallery__media').forEach(function(mediaEl) {
      var variantIdsStr = mediaEl.getAttribute('data-variant-ids');
      // Always show media that aren’t linked to a variant.
      if (!variantIdsStr || variantIdsStr.trim() === "") {
        mediaEl.removeAttribute('hidden');
        return;
      }
      // Split the string and trim each id.
      var variantIds = variantIdsStr.split(',').map(function(id) { return id.trim(); });
      // Show only if the active variant id is in the list.
      if (variantIds.includes(String(selectedVariantId))) {
        mediaEl.removeAttribute('hidden');
      } else {
        mediaEl.setAttribute('hidden', true);
      }
    });

  // Select all carousel navigation dots.
  var dots = document.querySelectorAll('carousel-navigation button.tap-area');
  dots.forEach(function(dot) {
    // Get the media ID associated with this dot.
    var mediaId = dot.getAttribute('data-media-id');
    // Find the corresponding media element.
    var mediaEl = document.querySelector('.product-gallery__media[data-media-id="' + mediaId + '"]');
    // If the media element exists and is hidden, hide the dot.
    if (mediaEl && mediaEl.hasAttribute('hidden')) {
      dot.setAttribute('hidden', true);
    } else {
      dot.removeAttribute('hidden');
    }
  });

  }

// Scroll to top  
// Only run on mobile devices (max-width: 768px)
  if (window.matchMedia("(max-width: 768px)").matches) {
    // Use a delegated click listener on document in capture phase
    document.addEventListener('click', function(event) {
  const label = event.target.closest('label');

  if (label) {
    const forAttr = label.getAttribute('for') || '';
    
    // If the label is for an option2 input (position2 = frame)
    if (forAttr.includes('-option2-')) {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, 200);
    }
  }
}, true);

  }

  // Retrieves the actual variant id from the product form's hidden input.
  function getSelectedVariantId() {
    var variantInput = document.querySelector('form [name="id"]');
    if (variantInput) {
      return variantInput.value;
    }
    // Fallback to the checked radio input if needed.
    var checkedRadio = document.querySelector('.variant-picker__option-values input[type="radio"]:checked');
    if (checkedRadio) {
      return checkedRadio.value;
    }
    return null;
  }

  // On page load, filter the gallery.
  var initialVariantId = getSelectedVariantId();
  if (initialVariantId) {
    updateGallery(initialVariantId);
  }

  // Listen for the "product:rerender" event dispatched by the variant picker
  // (this event fires when the product form is re-rendered after a variant change).
  document.addEventListener("product:rerender", function(e) {
    // Wait a short moment for the new HTML to be injected.
  //  setTimeout(function() {
      var currentVariantId = getSelectedVariantId();
      if (currentVariantId) {
        updateGallery(currentVariantId);
      }
//    }, 100);
  });

  // Listen for the "variant:change" event.
  document.addEventListener("variant:change", function(e) {
    
      var currentVariantId = getSelectedVariantId();
      if (currentVariantId) {
        updateGallery(currentVariantId);
      }


      // Click on first carousel button
      const firstButton = document.querySelector('product-gallery carousel-navigation.page-dots button');
      // Wait a bit to ensure the hidden input and any re-render are updated.
      setTimeout(function() {
          if (firstButton) {
            firstButton.click();
          }
      }, 200);
    
      // Adjust the scroll: scroll to the active media with a small offset.
      /*
      var activeMedia = document.querySelector('.product-gallery__media:not([hidden])');
      if (activeMedia) {
        // For example, scroll so that the active media is 100px from the top.
       // var offset = activeMedia.getBoundingClientRect().top + window.pageYOffset - 100;
        var offset = activeMedia.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: offset, behavior: "smooth" });
      }
      */
    
  });
});
